import { ContentMetaData } from 'src/utils/ConsumptionHelper/types';
import { DynamicObject } from 'src/utils/commonTypes';
import { ASSET_TYPE } from 'src/utils/constants/AppConstants';

export enum ContentTypes {
  movies = 'movies',
  news = 'news',
  video = 'video',
  sports = 'sports',
  webSeries = 'web-series',
  music = 'music',
  tvshows = 'tv-shows',
  B2B = 'b2b',
  livetv = 'live-tv',
  kids = 'kids',
  celebs = '7',
  filmography = 'filmography'
}

export enum ThumbnailTypes {
  vertical = 'vertical',
  horizontal = 'horizontal',
  episode = 'episode',
  upnext = 'upnext',
  circular = 'circular',
  bellybanner = 'bellybanner',
  biggerHorizontal = 'biggerHorizontal',
  plex = 'plex'
  // squareTag= 'squareTag',
  // wideLandscapeTag= 'wideLandscapeTag'
}

export enum ContentGenres {
  comedy = 'comedy',
  drama = 'drama',
  thriller = 'thriller',
  horror = 'horror',
  action = 'action',
  adventure = 'adventure',
  biopic = 'biopic'
}

export interface ThumbnailComponentProps {
  id: string;
  type: ContentTypes;
  tagName: string;
  thumbnailType: ThumbnailTypes;
  title: string;
  imageUrl: string;
  slug: string;
  duration: number;
  contentId: string;
  genres?: ContentGenres[] | string[];
  tags?: string[];
  overout: boolean;
  displayTitleOnImg: boolean;
  episode?: string;
  businessType: string;
  billingType: string;
  date?: string;
  assetSubType: string;
  assetType: number;
  description: string;
  content?: DynamicObject;
  cardDetails?: CardDetailsType;
  contentPartner?: string;
  content_partner_details?: string;
  joystickIconCheck: boolean;
  dataTestId?: string;
  showTitleWithinThumbnail?: boolean;
  ageRating?: string;
  isCommerceItem?: boolean;
  showHover?: boolean;
  isSearchLanding?: boolean;
}
export interface ThumbnailCTAProps {
  watchCallback?: (e: any) => void;
  shareItems: ShareItemProps;
  cardDetails?: CardDetailsType;
}
export interface ThumbnailMetadataProps {
  tags: string[];
  overout: boolean;
  type?: string;
}
export interface ThumbnailImageProps {
  title?: string;
  slug: string;
  assetType: ASSET_TYPE;
  imageUrl: string;
  businessType: string;
  billingType: string;
  onClickHandler: (e: any) => void;
  width?: number;
  tagName?: string;
  thumbnailType: ThumbnailTypes;
  contentPartner?: string;
  content_partner_details?: string;
  joystickIconCheck?: boolean;
  children?: React.ReactNode;
}

export interface UpNextEpisodeRequestBody {
  episodeId: string;
  seasonId: string;
  type: string;
  limit: number;
  translation: string;
  country: string;
  page: number;
}

export interface ShareItemProps {
  title: string;
  slug: string;
  assetSubType: string;
  assetType: number;
  description: string;
}

export interface CardDetailsType {
  contentId: string;
  title: string;
  horizontalIndex: number;
  verticalIndex: number;
  assetSubtype?: string;
  originalTitle?: string;
}

export enum ContentPartnerImage {
  logoRectancleDarkeBG = 'logo_rectangle_darkbg',
  logoRectangleWhiteBG = 'logo_rectangle_whitebg',
  logoCircleDarkBG = 'logo_circle_darkbg',
  logoCircleWhiteBG = 'logo_circle_whitebg',
  purchaseImage = 'purchase_image'
}

export type ContentPartnerImageType = {
  logo_rectangle_darkbg: string;
  logo_rectangle_whitebg: string;
  logo_circle_darkbg: string;
  logo_circle_whitebg: string;
  purchase_image: string;
};
export type ContentPartnerDetailsTypes = {
  content_partner_images: ContentPartnerImageType;
  content_partner_id: string;
  content_partner_name: string;
  content_partner_deeplink: string;
};

export type ReferralContentItemType = {
  title: string;
  referralDeepLink: string;
};
